// Interruptor de la pasarela de pago (CardNet). Debe coincidir con
// PAYMENT_GATEWAY_ENABLED del API (src/utils/common/paymentGateway.ts).
// En Costa Rica está apagado hasta definir la red de pago del país: se
// ocultan "Mis métodos de Pago" y los recetarios se registran sin cobro.
export const PAYMENT_GATEWAY_ENABLED = true;
